<template>
    <section>
        <mu-divider style="position:absolute;top:0;bottom:10px;margin:auto;" /> &nbsp;&nbsp;分割线
    </section>
</template>
<script>
export default {
    name: 'divider'
}
</script>



// WEBPACK FOOTER //
// divider.vue?28ed0ea2